// number regex
export const numberDecimalRegex= new RegExp('^([1-9][0-9]*|0)(\\.[0-9]+)?$');
export const positiveIntNumber = new RegExp("^[0-9]+$");

//input regex
export const nameRegex = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ]{2,}(?: [A-Za-zÀ-ÖØ-öø-ÿ]+)*$");
export const passwordRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/);
export const emailRegex = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
export const hexColorRegex = new RegExp(/^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/);